import { COMPANY_STATUS } from '../constants';

export const PRIMARY_USER_FIELDS = [
  {
    key: 'p_c_name',
    label: 'Name',
    placeholder: 'Enter first and last name of the primary user',
  },
  {
    key: 'p_c_email',
    label: 'Email address',
    placeholder: "Enter primary user's email address",
  },
  {
    key: 'p_c_phone',
    label: 'Phone number',
    placeholder: "Enter primary user's phone number (optional)",
  },
];

export const SHOP_PRIORITIES = {
  HIGH: 1,
  MEDIUM: 2,
  LOW: 3,
};

export const SHOP_PRIORITIES_LABELS = {
  [SHOP_PRIORITIES.HIGH]: 'High',
  [SHOP_PRIORITIES.MEDIUM]: 'Medium',
  [SHOP_PRIORITIES.LOW]: 'Low',
};

export const SHOP_TIME = {
  EARLY_MONTH: 1,
  MID_MONTH: 2,
  LATE_MONTH: 3,
};

export const SHOP_TIME_LABELS = {
  [SHOP_TIME.EARLY_MONTH]: 'Early month',
  [SHOP_TIME.MID_MONTH]: 'Mid month',
  [SHOP_TIME.LATE_MONTH]: 'Late month',
};

export const SHOPS_PER_YEAR = {
  QUARTERLY: 4,
  SEMI_ANNUALLY: 2,
};

export const SHOPS_PER_YEAR_LABELS = {
  [SHOPS_PER_YEAR.SEMI_ANNUALLY]: '2 shops',
  [SHOPS_PER_YEAR.QUARTERLY]: '4 shops',
};

export const COMPANY_MYSTERY_SHOP_SETTING_INITIAL_VALUES = {
  shop_time: SHOP_TIME.MID_MONTH,
  shop_priority: SHOP_PRIORITIES.MEDIUM,
  shops_per_year: SHOPS_PER_YEAR.QUARTERLY,
  shop_months: [],
};

export const COMPANY_INITIAL_VALUES = {
  name: '',
  primary_user_id: null,
  p_c_name: '',
  p_c_phone: '',
  p_c_email: '',
  status: COMPANY_STATUS.IN_TRIAL,
  mystery_shop_setting: COMPANY_MYSTERY_SHOP_SETTING_INITIAL_VALUES,
  shop_requests: [],
};

export const MONTHS = [
  { label: 'Jan', value: 1 },
  { label: 'Feb', value: 2 },
  { label: 'Mar', value: 3 },
  { label: 'Apr', value: 4 },
  { label: 'May', value: 5 },
  { label: 'Jun', value: 6 },
  { label: 'Jul', value: 7 },
  { label: 'Aug', value: 8 },
  { label: 'Sep', value: 9 },
  { label: 'Oct', value: 10 },
  { label: 'Nov', value: 11 },
  { label: 'Dec', value: 12 },
];

export const COMPANY_KEYS = {
  NAME: 'name',
  PRIMARY_USER_ID: 'primary_user_id',
  P_C_NAME: 'p_c_name',
  P_C_EMAIL: 'p_c_email',
  P_C_PHONE: 'p_c_phone',
  STATUS: 'status',
  SHOP_REQUESTS: 'shop_requests',
  MYSTERY_SHOP_SETTING: 'mystery_shop_setting',
} as const;

export const MYSTERY_SHOP_SETTING_KEYS = {
  SHOP_TIME: 'shop_time',
  SHOP_PRIORITY: 'shop_priority',
  SHOPS_PER_YEAR: 'shops_per_year',
  SHOP_MONTHS: 'shop_months',
} as const;
